import { Component, Input } from '@angular/core';

@Component({
  selector: 'ptl-content-item-image',
  templateUrl: './content-item-image.component.html',
  styleUrls: ['./content-item-image.component.scss'],
})
export class ContentItemImageComponent {
  @Input() imageUrl: string;
  @Input() title: string;
}
